import React from 'react'
import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'

const invertedSorting = 'title'

class TableHeaders extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      filters: this.props.sortingFilters,
      direction: this.props.sortingFilters.sortBy,
    }
  }

  handleClick(value, sortable) {
    if (sortable) {
      const filters = this.state.filters
      let direction = this.state.direction[1]

      if (this.state.direction[0] === value) {
        direction = direction === 'asc' ? 'desc' : 'asc'
      } else {
        direction = value === invertedSorting ? 'asc' : 'desc'
      }

      filters.sortBy = [value, direction]
      filters.page = 1

      this.setState((prevState) => ({
        ...prevState.filters,
        direction: [value, direction],
      }), this.handleFiltersChange(filters, value, direction))
    } else {
      return false
    }
  }

  handleFiltersChange(filters, title, direction) {
    this.props.sortingChange(filters)
    this.getArrow(title, direction)
  }

  getArrow(title, direction) {
    if (title === this.state.direction[0]) {
      if (direction === 'desc') {
        return title === invertedSorting ? 'caret-up' : 'caret-down'
      }
      return title === invertedSorting ? 'caret-down' : 'caret-up'
    }
    return 'sort'
  }

  getClassName(sortable, name, centered) {
    const sortableClass = sortable ? (name === this.state.direction[0] ? 'is-sortable is-active' : 'is-sortable') : ''
    const centeredClass = centered ? 'u-text-center' : ''

    return sortableClass + centeredClass
  }

  render() {
    return (
      <thead>
        <tr>
          {this.props.select
          && (
          <th className="selector u-text-center" onClick={this.props.selectAll}>
            <input
              type="checkbox"
              id="select-all-models"
              className="checkbox"
              onChange={this.props.selectAll}
              checked={this.props.isSelected}
            />
            <label htmlFor="select-all-models" />
          </th>
          )
          }
          {this.props.headers.map((column) => (
            <th
              key={column.value}
              className={this.getClassName(column.sortable, column.value, column.centered)}
              onClick={() => this.handleClick(column.value, column.sortable)}
            >
              {column.title}
              {column.sortable
                && (
                <Icon
                  type={['fas', this.getArrow(column.value, this.state.direction[1])]}
                  className="sorting-icon ml-5"
                  size="sm"
                />
                )
              }
            </th>
          ))}
        </tr>
      </thead>
    )
  }
}

TableHeaders.propTypes = {
  headers: PropTypes.array.isRequired,
  sortingFilters: PropTypes.object,
  sortingChange: PropTypes.func,
  select: PropTypes.bool,
  selectAll: PropTypes.func,
  isSelected: PropTypes.bool,
}

TableHeaders.defaultProps = {
  sortingChange: () => {},
  sortingFilters: {},
  select: true,
  selectAll: () => {},
  isSelected: false,
}

export default TableHeaders
